export default __webpack_public_path__ + "static/media/iconFileGif.94603b59.svg";